import React, { useEffect, useState } from "react";
import styles from "./CustomCaoursel.module.scss";
import CarouselCard from "./CarouselCard.tsx";

interface GlobalCarouselProps {
  imageGroups: { imgSrc: string; text: string }[][]; // Nested array structure
  activeIndex: number;
  handleIndicatorClick: (index: number) => void;
  cols: number;
  itemsCount?: number;
}

const GlobalCarousel: React.FC<GlobalCarouselProps> = ({
  imageGroups,
  activeIndex,
  handleIndicatorClick,
  cols,
  itemsCount = 6,
}) => {
  const chunkArray = (
    array: { imgSrc: string; text: string }[],
    chunkSize: number
  ) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const useChunkSize = () => {
    const [chunkSize, setChunkSize] = useState(itemsCount);

    useEffect(() => {
      const updateChunkSize = () => {
        if (window.innerWidth < 767) {
          setChunkSize(4);
        } else if (window.innerWidth < 991) {
          setChunkSize(6);
        } else {
          setChunkSize(itemsCount);
        }
      };

      updateChunkSize();
      window.addEventListener("resize", updateChunkSize);

      return () => window.removeEventListener("resize", updateChunkSize);
    }, []);

    return chunkSize;
  };

  const chunkSize = useChunkSize();
  const imagesGroups = chunkArray(imageGroups.flat(), chunkSize);
  return (
    <div
      id="carouselExampleIndicators"
      className={`${styles.carouselSlide} carousel slide w-100`}
      data-bs-ride="carousel"
    >
      <div className="carousel-inner h-100">
        {imagesGroups.map((images, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""} h-100`}
          >
            <div className="d-flex flex-column justify-content-evenly h-100">
              <div className="row">
                {images.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-${cols} col-md-4 col-6 mb-4 d-flex justify-content-center`}
                  >
                    <CarouselCard imgSrc={items.imgSrc} text={items.text} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.carouselIndicators}>
        {imagesGroups.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to={index.toString()}
            className={index === activeIndex ? `${styles.active}` : ""}
            aria-current={index === activeIndex ? "true" : undefined}
            aria-label={`Slide ${index + 1}`}
            onClick={() => handleIndicatorClick(index)}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default GlobalCarousel;
